export default "__VITE_ASSET__$_ia9B9U__"